<template>
  <header class="page-header publication-header">
    <BranchShape v-scroll:reveal="{ delay: 75 }" class="layout-cta__branch" color="white" :opacity="0.4" header />

    <section class="page-header__container">
      <BreadCrumbs />

      <h1 v-if="publication" v-scroll:reveal="{ delay: 50 }" class="publication-header__banner">
        {{ publication.title }}
      </h1>

      <div v-if="publication" class="publication-header__meta">
        <RouterLink
          v-if="tag"
          v-scroll:reveal="{ delay: 150 }"
          :to="{ name: 'event-index', query: { eventType } }"
          class="tag -float -small"
        >
          <SvgIcon :id="icon" />
          {{ tag }}
        </RouterLink>

        <section class="publication-header__submeta">
          <div v-scroll:reveal="{ delay: 200 }" class="publication-header__data">
            <SvgIcon id="content-date" />
            <p>{{ formattedDate || 'Aucune date' }}</p>
          </div>
        </section>
      </div>
    </section>
  </header>
</template>

<script>
import moment from 'moment'
import { eventTypeTagMap, eventTypeIconMap } from '@/helpers/type-maps'

export default {
  name: 'EventsSingleHeader',
  props: {
    publication: {
      type: Object,
      default: null
    }
  },
  computed: {
    eventType() {
      return this.publication ? this.publication.eventType : null
    },
    tag() {
      return eventTypeTagMap[this.eventType]
    },
    icon() {
      return eventTypeIconMap[this.eventType]
    },
    formattedDate() {
      return this.publication && this.publication.date ? moment(this.publication.date).format('D MMMM YYYY') : null
    }
  }
}
</script>
